import { render, staticRenderFns } from "./PageNotFound_Desktop.vue?vue&type=template&id=b3c196f6&scoped=true&"
import script from "./PageNotFound_Desktop.vue?vue&type=script&lang=js&"
export * from "./PageNotFound_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound_Desktop.vue?vue&type=style&index=0&id=b3c196f6&prod&lang=css&"
import style1 from "./PageNotFound_Desktop.vue?vue&type=style&index=1&id=b3c196f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c196f6",
  null
  
)

export default component.exports